import React from "react";
import AdminLayout from "./components/AdminLayout";

function Users() {
  return (
    <AdminLayout>
      <h2>Users Page</h2>
      <p>Manage users here</p>
    </AdminLayout>
  );
}

export default Users;